<template>
  <div class="vehicle">
    <div class="col-12">
      <div class="row">
        <div class="col-6">
          <h2>Vehicle Detail</h2>
        </div>
      </div>
    </div>
    <div v-if="vehicle">
      <div class="row">
        <div class="col-2">
          <label for="name">Name:</label>
        </div>
        <div class="col-8">
          <input
            type="text"
            class="form-control"
            id="name"
            ref="vehicle_name"
            name="name"
            placeholder="name"
            :value="getName()"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="description">Description:</label>
        </div>
        <div class="col-8">
          <input
            type="text"
            class="form-control"
            id="description"
            ref="vehicle_description"
            name="description"
            placeholder="description"
            :value="getDescription()"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="registration">Registration:</label>
        </div>
        <div class="col-4">
          <input
            type="text"
            class="form-control"
            id="registration"
            ref="vehicle_registration"
            name="registration"
            placeholder="registration"
            :value="getRegistration()"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="service_due">Service Due Date:</label>
        </div>
        <div class="col-4">
          <input
            type="date"
            class="form-control"
            id="service_due"
            ref="vehicle_service_due"
            name="service_due"
            :value="getServiceDueDate()"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-10">
        <button id="new" @click="$emit('new')" class="btn btn-plt">
          New
        </button>
        <button v-if="vehicle" id="save" @click="save" class="btn btn-plt">
          Save
        </button>
      </div>
      <div class="col-2" v-if="vehicle">
        <button
          id="delete"
          v-if="vehicle.active"
          @click="_delete"
          class="btn btn-danger"
        >
          Delete
        </button>
        <button id="delete" v-else @click="_delete" class="btn btn-primary">
          Reactivate
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "VehicleDetail",
  props: {
    vehicle: {
      type: Object,
      default: null,
    },
  },
  data: () => ({}),
  methods: {
    ...mapActions("vehicles", ["apiSaveVehicle", "apiCreateVehicle"]),
    _delete() {
      if (this.vehicle && this.vehicle.id > 0) {
        this.vehicle.active = !this.vehicle.active;
        this.apiSaveVehicle(this.vehicle);
      }
    },
    save() {
      if (this.vehicle) {
        this.vehicle.name = this.$refs.vehicle_name.value;
        this.vehicle.registration = this.$refs.vehicle_registration.value;
        this.vehicle.description = this.$refs.vehicle_description.value;
        this.vehicle.service_due = this.$refs.vehicle_service_due.value;

        if (this.vehicle.id > 0) {
          this.apiSaveVehicle(this.vehicle);
        } else {
          this.apiCreateVehicle(this.vehicle);
        }
        this.$emit("saved");
      }
    },
    getName() {
      if (this.vehicle == null) {
        return "";
      } else {
        return this.vehicle.name;
      }
    },
    getRegistration() {
      if (this.vehicle == null) {
        return "";
      } else {
        return this.vehicle.registration;
      }
    },
    getDescription() {
      if (this.vehicle == null) {
        return "";
      } else {
        return this.vehicle.description;
      }
    },
    getServiceDueDate() {
      if (this.vehicle == null) {
        return "";
      } else {
        return this.vehicle.service_due;
      }
    },
  },
  components: {},
};
</script>
